import React, {memo, useState, useMemo} from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import CustomToggle from 'helpers/CustomToggle';
import Avatar from 'components/atoms/Avatar';
import useAsync from 'User/helpers/hooks/useAsync';
import {logoutUser} from 'providers/user/auth';
import {showNotification} from 'helpers/Notifications';
import {initialName} from 'helpers/text';
import {getDropdownItems} from './utils';

const HeaderUser = ({account, translations, lang = 'en'}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {execute} = useAsync();

  const handleOpen = () => setIsOpen((open) => !open);

  const onLogout = async () => {
    const {isSuccess} = await execute(logoutUser());
    if (isSuccess) {
      localStorage.removeItem('user');
      showNotification(translations.logoutSuccessful);
      window.location.reload();
    }
  };

  const dropdownItems = useMemo(
    () => getDropdownItems(lang, translations, onLogout),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lang, translations]
  );

  return (
    <Dropdown
      id="header-user"
      onToggle={handleOpen}
      open={isOpen}
      componentClass="div"
    >
      <CustomToggle
        bsRole="toggle"
        className="cursor-pointer d-flex align-items-center text-white"
      >
        <Avatar>{initialName(account.firstName, account.lastName)}</Avatar>
      </CustomToggle>

      <Dropdown.Menu className="dropdown-menu-right">
        {dropdownItems.map(({Icon, href, onClick, text}) => (
          <li key={text}>
            <a
              href={href}
              onClick={(e) => {
                if (onClick) {
                  e.preventDefault();
                  onClick();
                }
                setIsOpen(false);
              }}
              className="select-list-group list-group-flush px-2 py-2
                d-flex align-items-center cursor-pointer header-user-dropdown-item"
            >
              <Icon className="mr-2 header-user-dropdown-icon" />
              {text}
            </a>
          </li>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

HeaderUser.propTypes = {
  account: PropTypes.shape({
    userAccountID: PropTypes.string.isRequired,
    userID: PropTypes.string.isRequired,
    providerUserID: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    screenName: PropTypes.string.isRequired,
    birthDate: PropTypes.string.isRequired,
    dateCreated: PropTypes.number.isRequired,
    nationality: PropTypes.string.isRequired,
    newsletter: PropTypes.bool.isRequired
  }).isRequired,
  translations: PropTypes.shape({
    logout: PropTypes.string,
    account_dashboard_dropdown: PropTypes.string,
    my_bookings: PropTypes.string,
    mobile_more_support: PropTypes.string,
    logoutSuccessful: PropTypes.string
  }).isRequired,
  lang: PropTypes.string
};

export default memo(HeaderUser);
